import type { HelpLocale } from './help';

/**
 * The chatbot's own strings.
 *
 * Lifted out of infostation.html by EVALUATING the original literal rather than retyping it —
 * these are three languages' worth of prose with accents and typographic apostrophes, and a
 * hand copy is how one of them quietly loses a character that no test would notice.
 *
 * Falls back to English for an unknown locale, exactly as the vanilla `chatText()` did: a
 * missing translation should show the English rather than nothing at all.
 */
export const CHAT_I18N = {
  "title": {
    "en": "AI help",
    "fr": "Aide IA",
    "de": "KI-Hilfe"
  },
  "placeholder": {
    "en": "Ask about the documentation…",
    "fr": "Posez une question sur la documentation…",
    "de": "Fragen Sie zur Dokumentation…"
  },
  "send": {
    "en": "Send",
    "fr": "Envoyer",
    "de": "Senden"
  },
  "thinking": {
    "en": "Thinking…",
    "fr": "Réflexion…",
    "de": "Einen Moment…"
  },
  "empty": {
    "en": "Ask a question about the documentation. I'll answer from what you're allowed to see and highlight the related nodes on the map.",
    "fr": "Posez une question sur la documentation. Je réponds à partir de ce que vous pouvez voir et je surligne les nœuds concernés sur la carte.",
    "de": "Stellen Sie eine Frage zur Dokumentation. Ich antworte anhand des für Sie Sichtbaren und hebe die zugehörigen Knoten auf der Karte hervor."
  },
  "error": {
    "en": "Something went wrong. Please try again.",
    "fr": "Une erreur est survenue. Réessayez.",
    "de": "Etwas ist schiefgelaufen. Bitte erneut versuchen."
  }
} as const;

export type ChatKey = keyof typeof CHAT_I18N;

export function chatText(key: ChatKey, locale: string): string {
  const s = CHAT_I18N[key] as Record<string, string> | undefined;
  return (s && (s[locale as HelpLocale] ?? s.en)) || '';
}
